module.exports = __webpack_public_path__ + "static/media/loading.3e803924.gif";